import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ImageUpload from "./ImageUpload";
import { searchArtist,createEventArtist } from "../../services/eventService";
import { ARTIST_GROUP_ID } from "../../common/artistConstants";

const CreateArtist = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const eventNature = location.state?.eventNature;
  const cityId = location.state?.cityId;
  const [artistImages, setArtistImages] = useState([]);


  const [artists, setArtists] = useState([
    { artistId: null, name: "", role: "", about: "", group: "", search: "", images: [] },
  ]);

  const [searchResults, setSearchResults] = useState([]);

  /* ADD ARTIST */
  const addArtist = () => {
    setArtists([
      ...artists,
      { artistId: null, name: "", role: "", about: "", group: "", search: "", images: [] },
    ]);
  };

  /* REMOVE ARTIST */
  const removeArtist = (index) => {
    const updated = artists.filter((_, i) => i !== index);
    setArtists(updated);
  };

  /* HANDLE INPUT CHANGE */
  const handleChange = (index, field, value) => {
    const updated = [...artists];
    updated[index][field] = value;
    setArtists(updated);
  };

  /* UPDATE ARTIST IMAGES */
  const updateArtistImages = (index, images) => {
    const updated = [...artists];
    updated[index].images = images;
    setArtists(updated);
  };

  /* SEARCH ARTIST */
  const handleArtistSearch = async (index, value) => {
    handleChange(index, "search", value);

    if (value.length < 2) {
      setSearchResults([]);
      return;
    }

    try {
      const res = await searchArtist(value);
      setSearchResults(res.data);
    } catch (error) {
      console.error("Artist search failed:", error);
    }
  };

  /* SELECT ARTIST FROM SEARCH */
  const selectArtist = (index, artist) => {
    const updated = [...artists];

    updated[index] = {
      ...updated[index],
      artistId: artist.id,
      name: artist.artistName || "",
      role: artist.role || "",
      group: artist.groupId || "",
      about: artist.description || "",
      search: artist.artistName || "",
      images: artist.artistImages || [],
    };

    setArtists(updated);
    setSearchResults([]);
  };

  /* SUBMIT */
 const handleSubmit = async () => {
console.log(artists)
 const imageList = artistImages.map((url, index) => ({
      id: 0,
      imageUrl: url.url,
      altText: `artist-image-${index + 1}`,
      isFeatured: index === 0, // first image as featured
      status: "ACTIVE",
      entityType: "ARTIST",
      createdBy: 1,
      description: "",
      mediaType: "IMAGE",
    }));

   const payload = artists.map((artist) => ({
     id: artist.artistId || 0,
     eventId: Number(eventId),
     artistGroupId: Number(artist.group),
     artistName: artist.name,
     description: artist.about,
     status: "ACTIVE",
     createdBy: 1,
     artistImages: imageList,
     artistRole: artist.role,
     eventArtistGroupId: Number(artist.group)
   }));


   console.log("Artist Payload:", payload);

   try {

     await createEventArtist(payload);
     navigate(`/create-venue/${eventId}`, {
           state: { eventNature,cityId }
         });

   } catch (error) {

     console.error("Artist creation failed:", error);

   }
 };

  return (
    <div className="px-0 py-5">

      {/* Breadcrumb */}
      <div className="text-xs mb-4 flex gap-1">
        <span className="text-gray-400">Home /</span>
        <span className="text-black font-medium">Create an Event</span>
      </div>
     {/* Step Indicator */}
     {/* Step Indicator */}
     <div className="flex flex-wrap items-center justify-start gap-y-6 mb-10">

       {[1, 2, 3, 4].map((step, index) => (
         <div key={step} className="flex items-center">

           <div
             className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-xs sm:text-sm font-semibold
             ${
               step === 1
                 ? "bg-[#65AE5C] text-white"
                 : step === 2
                 ? "bg-yellow-400 text-white"
                 : "bg-gray-300 text-white"
             }`}
           >
             {step}
           </div>

           {index !== 3 && (
             <div className="flex items-center mx-2 sm:mx-4">
               <div className="w-8 sm:w-16 h-[2px] bg-neutral-400"></div>
               <div className="w-0 h-0 border-t-[5px] border-b-[5px] border-l-[8px] border-t-transparent border-b-transparent border-l-neutral-400"></div>
             </div>
           )}

         </div>
       ))}

     </div>

      {/* TITLE */}
      <h1 className="text-2xl font-semibold mb-10">Create an Artist</h1>

      {artists.map((artist, index) => (
        <div key={index} className="bg-white mt-12 relative">

          {/* DELETE ICON */}
          {artists.length > 1 && (
            <button
              onClick={() => removeArtist(index)}
              className="absolute top-5 right-5 text-red-500"
            >
              🗑
            </button>
          )}

          <div className="text-black text-2xl font-medium">
            Artist {index + 1}
          </div>

          <div className="border-t-2 border-neutral-400 mt-6 mb-8"></div>

          <div className="text-black text-xl font-medium mb-6">
            Cast/Crew Details
          </div>

          {/* SEARCH ARTIST */}
          <div className="relative w-full mb-8">

            <input
              type="text"
              placeholder="Search Artist"
              value={artist.search}
              onChange={(e) =>
                handleArtistSearch(index, e.target.value)
              }
              className="w-full h-12 px-5 pr-12 border border-neutral-200 outline-none"
            />

            {/* SEARCH ICON */}
            <svg
              className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>

            {/* SEARCH RESULTS */}
            {searchResults.length > 0 && (
              <div className="absolute w-full bg-white border border-gray-200 mt-1 z-10">
                {searchResults.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => selectArtist(index, item)}
                    className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                  >
                  {console.log(item)}
                    {item.artistName}
                  </div>
                ))}
              </div>
            )}

          </div>

          {/* INPUT GRID */}
          <div className="grid grid-cols-2 gap-10">

            {/* ARTIST NAME */}
            <input
              type="text"
              placeholder="Artist Name"
              value={artist.name}
              onChange={(e) =>
                handleChange(index, "name", e.target.value)
              }
              className="w-full h-12 px-5 pr-12 border border-neutral-200 focus:ring-0 outline-none"
            />

            {/* GROUP */}
            <select
              value={artist.group}
              onChange={(e) =>
                handleChange(index, "group", e.target.value)
              }
              className="h-12 px-5 border border-neutral-200"
            >
              <option value="">Select Artist Group</option>

              {ARTIST_GROUP_ID.map((group) => (
                <option key={group.value} value={group.value}>
                  {group.label}
                </option>
              ))}

            </select>

            {/* ROLE */}
            <input
              type="text"
              placeholder="Role of Artist"
              value={artist.role}
              onChange={(e) =>
                handleChange(index, "role", e.target.value)
              }
              className="w-full h-12 px-5 pr-12 border border-neutral-200 focus:ring-0 outline-none"
            />

          </div>

          {/* ABOUT */}
          <textarea
            placeholder="About the artist"
            value={artist.about}
            onChange={(e) =>
              handleChange(index, "about", e.target.value)
            }
            className="w-full h-40 px-5 py-3 border border-neutral-200 mt-8 focus:ring-0 outline-none"
          />



          <ImageUpload
            images={artistImages}
            setImages={setArtistImages}
            title="Upload Artist Image"
            multiple={true}
          />

        </div>
      ))}

      {/* ADD ARTIST */}
      <div className="flex justify-end mt-10">
        <button
          onClick={addArtist}
          className="w-80 h-12 border border-black"
        >
          Add New Artist
        </button>
      </div>

      {/* SAVE */}
      <div className="flex justify-end mt-10">
        <button
          onClick={handleSubmit}
          className="w-80 h-12 bg-[#65AE5C] text-white"
        >
          Save and Continue
        </button>
      </div>

    </div>
  );
};

export default CreateArtist;